import { render, staticRenderFns } from "./customPageButtonSettings.vue?vue&type=template&id=7d8b6f2e&scoped=true"
import script from "./customPageButtonSettings.vue?vue&type=script&lang=js"
export * from "./customPageButtonSettings.vue?vue&type=script&lang=js"
import style0 from "./customPageButtonSettings.vue?vue&type=style&index=0&id=7d8b6f2e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d8b6f2e",
  null
  
)

export default component.exports